var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudComputing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea6190;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Software_Development",
    "data-name": "Software Development"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,10A10,10,0,0,1,10,0H40A10,10,0,0,1,50,10V40A10,10,0,0,1,40,50H10A10,10,0,0,1,0,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.76,23.43a8.61,8.61,0,0,0,.15-1.61,8.84,8.84,0,0,0-16.42-4.54,6.85,6.85,0,0,0-6.14.85,6.77,6.77,0,0,0-3,5.37,6.93,6.93,0,0,0-4,6.18A6.77,6.77,0,0,0,8.58,31h0a6.89,6.89,0,0,0,6.74,5.53H35a6.84,6.84,0,0,0,2.8-13.13Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudComputing);
export default __webpack_public_path__ + "static/media/Cloud-Computing.bb78e4ecb3dceea7622d51ded3c33deb.svg";
export { ForwardRef as ReactComponent };